import api from '@/api'

export default {
  namespaced: true,

  state: () => ({
    totalSales: 0,
    netTotal: 0,
    batchSales: [],
    batchPurchases: []
  }),

  actions: {
    getTotalSales: async function (ctx, params) {
      const response = await api.get(`/v1/restaurants/${ctx.rootState.currentRestaurant.data._id}/reports/total-sales`, params)

      ctx.commit('setTotalSales', (response || {}).total || 0)
    },
    getNetTotal: async function (ctx, params) {
      const response = await api.get(`/v1/restaurants/${ctx.rootState.currentRestaurant.data._id}/reports/net-total`, params)

      ctx.commit('setNetTotal', (response || {}).total || 0)
    },
    getBatchSales: async function (ctx, params) {
      const response = await api.get(`/v1/restaurants/${ctx.rootState.currentRestaurant.data._id}/reports/total-sales-batch`, params)

      ctx.commit('setBatchSales', response)
    },
    getBatchPurchases: async function (ctx, params) {
      const response = await api.get(`/v1/restaurants/${ctx.rootState.currentRestaurant.data._id}/reports/purchases-by-area-batch`, params)

      ctx.commit('setBatchPurchases', response)
    }
  },

  mutations: {
    setTotalSales: function (state, total) {
      state.totalSales = total
    },

    setBatchSales: function (state, sales) {
      state.batchSales = sales
    },

    setNetTotal: function (state, total) {
      state.netTotal = total
    },

    setBatchPurchases: function (state, purchases) {
      state.batchPurchases = purchases
    },

    reset: function (state) {
      state.totalSales = 0
      state.netTotal = 0
      state.batchSales = []
      state.batchPurchases = []
    }
  },

  getters: {
    totalCost: function (state) {
      return Number(state.netTotal) > 0 && Number(state.totalSales) > 0 ? (Number(state.netTotal) * 100) / Number(state.totalSales) : 0
    },
    batchCostByArea: function (state, getters, rootState, rootGetters) {
      const areas = rootGetters.areas
      return [...state.batchPurchases].sort((a, b) => {
        if (a.date < b.date) return -1
        if (a.date > b.date) return 1
        return 0
      }).map(p => {
        const totalSaleInPeriod = state.batchSales.find(s => s.date === p.date)
        p.result = p.result.map(r => ({
          ...r,
          areaName: (areas.find(a => a._id === r.area) || {}).name || 'Sin área',
          cost: Number(totalSaleInPeriod.total) > 0 && Number(r.total) > 0 ? ((Number(r.total) * 100) / Number(totalSaleInPeriod.total)).toFixed(2) : 0
        }))
        return p
      })
    }
  }
}
